export default function ToggleSwitch({ checked, onChange, isCheckboxDisabled }) {
  return (
    <div className="flex items-center gap-3">
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={isCheckboxDisabled}
          className="sr-only peer"
        />
        <div
          className="w-11 h-6 bg-gray-200 rounded-full peer
          peer-checked:bg-green-500 peer-focus:ring-2
          peer-focus:ring-[#1E3A5F] transition-all duration-300
          after:content-[''] after:absolute after:top-[2px]
          after:left-[2px] after:bg-white after:rounded-full
          after:h-5 after:w-5 after:transition-all
          peer-checked:after:left-[calc(100%-2px)] peer-checked:after:-translate-x-full"
        ></div>
      </label>
    </div>
  );
}

